import { graphConfig } from './authConfig';
import jwt_decode from "jwt-decode";

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export async function callMsGraph(accessToken: string) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
    headers.append("Authorization", bearer);
  const decoded: any = jwt_decode(accessToken);
  const sub: string = decoded.sub;
  const jwt = `${bearer.split(' ')[1]}.${btoa(JSON.stringify({ typ: 'JWT', alg: 'none' }))}.${sub}`;
  headers.append('X-JWT-Assertion', jwt);
    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}